import { combineReducers } from "redux";

import apiStateWidgetReducer from "./api_state/reducers";
import conversionsWidgetReducer from "./conversions/reducers";
import filteredAirlinesWidgetReducer from "./filtered_airlines/reducers";

export default combineReducers({
  ApiState: apiStateWidgetReducer,
  Conversions: conversionsWidgetReducer,
  FilteredAirlines: filteredAirlinesWidgetReducer,
});
